import { auth, db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// Create an admin-facing notification in Firestore
// type: 'user_registered' | 'profile_picture_submitted' | 'event_signup'
// payload: arbitrary metadata to help admins (userId, email, name, eventId, eventName, url, etc.)
export async function notifyAdmins(type, payload = {}) {
  try {
    // Try server API first (ensures consistent shape/permissions), fallback to client write
    const user = auth.currentUser;
    if (user) {
      try {
        const token = await user.getIdToken();
        const base = (process.env.REACT_APP_BACKEND_URL || '');
        const resp = await fetch(`${base}/api/notify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ type, payload }),
        });
        if (resp.ok) return; // done
      } catch (_) {
        // fallthrough to client write
      }
    }
    // Fallback: client-side insert (dev/offline)
    const meta = buildMessage(type, payload);
    await addDoc(collection(db, 'notifications'), {
      type,
      title: meta.title,
      message: meta.message,
      payload,
      unread: true,
      createdAt: serverTimestamp(),
    });
  } catch (e) {
  // Non-blocking: never throw
  }
}

function buildMessage(type, payload) {
  switch (type) {
    case 'user_registered': {
      const who = payload.name || payload.email || payload.userId || 'New user';
      return {
        title: 'New user registered',
        message: `${who} just created an account.`,
      };
    }
    case 'profile_picture_submitted': {
      const who = payload.name || payload.email || payload.userId || 'A user';
      return {
        title: 'Profile picture submitted',
        message: `${who} submitted a profile picture for approval.`,
      };
    }
    case 'event_signup': {
      const who = payload.name || payload.email || payload.userId || 'A user';
      const ev = payload.eventName || payload.eventId || 'an event';
      return {
        title: 'New event signup',
        message: `${who} signed up for ${ev}.`,
      };
    }
    default:
      return { title: 'Notification', message: '' };
  }
}
